/**
 * NIAP Service
 * Network Integration and Provisioning service
 */
import { niapClient } from "./client";

export const niapService = {
  /**
   * Submit installation request
   * @param {Object} data - Installation request data
   */
  submitInstallation(data) {
    return niapClient.post("/installation/submit", data);
  },

  /**
   * Check port availability
   * @param {Object} data - Port check data
   */
  checkPortAvailability(data) {
    return niapClient.post("/port/check", data);
  },

  /**
   * Reserve port
   * @param {Object} data - Port reservation data
   */
  reservePort(data) {
    return niapClient.post("/port/reserve", data);
  },

  /**
   * Get installation status
   * @param {string} referenceNumber - Installation reference number
   */
  getInstallationStatus(referenceNumber) {
    return niapClient.get(`/installation/status/${referenceNumber}`);
  },

  /**
   * Update installation details
   * @param {string} referenceNumber - Installation reference number
   * @param {Object} data - Updated installation data
   */
  updateInstallation(referenceNumber, data) {
    return niapClient.put(`/installation/${referenceNumber}`, data);
  },

  /**
   * Cancel installation
   * @param {string} referenceNumber - Installation reference number
   */
  cancelInstallation(referenceNumber) {
    return niapClient.post(`/installation/${referenceNumber}/cancel`);
  },
};

export default niapService;
